import PropTypes from 'prop-types';
import {Component} from 'react';
import {connect} from 'react-redux';
import cookie from '../../../../cookie';
import {recordBigQueryEvent, setErrorOnPage} from '../../../actions/paymentActions/threedsActions';
import {threeDSecureSuccess} from '../../../actions/site-actions';
import {getSettings} from '../../../selectors/selectors';
import getThreeDSecureData from '../../../selectors/ThreeDSSelectors/getThreeDSecureData';
import Track from '../../../utils/tracking';
import PostToIframe from '../ProviderAgnostic/PostToIframe';

const THREE_D_SECURE_API_RETURN_URL = `https://${window.location.host}/checkout/3ds-confirmation`;
const PROVIDER = 'WORLDPAY';

export class Worldpay3DSChallenge extends Component {
  constructor() {
    super();
  
    this.handleOnError = this.handleOnError.bind(this);
    this.handleOnLoad = this.handleOnLoad.bind(this);
  }
  
  handleOnError() {
    const errorMessage = 'Error loading WorldPay 3DS Challenge frame';
    Track.track(new Error(errorMessage));
    this.props.setErrorOnPage();
    try {
      recordBigQueryEvent('2ChallengeCompleted', PROVIDER,
        [{name: 'result', value: 'error'}], [{type: 'loading', value: errorMessage}]);
    } catch (error) {
      Track.track(error);
    }
  }
  
  handleOnLoad(event) {
    try {
      const loadedURL = event.target.contentWindow.location.href;
      // This only works once the user has returned to our site,
      // otherwise cross-origin error is thrown.
      if (loadedURL === THREE_D_SECURE_API_RETURN_URL) {
        this.props.threeDSecureSuccess();
        try {
          recordBigQueryEvent('2ChallengeCompleted', PROVIDER, [{name: 'result', value: 'success'}]);
        } catch (error) {
          Track.track(error);
        }
      } else {
        try {
          recordBigQueryEvent('2ChallengeInitiated', PROVIDER);
        } catch (error) {
          Track.track(error);
        }
      }
    } catch (exception) {
      // Couldn't determine iframe's location, likely because it's still on the bank's domain.
      try {
        recordBigQueryEvent('2ChallengeInitiated', PROVIDER);
      } catch (error) {
        Track.track(error);
      }
    }
  }
  
  render() {
    const {
      issuerURL, oneTime3DSToken, sessionId,
    } = this.props;
    
    try {
      recordBigQueryEvent('2ChallengeRequired', PROVIDER);
    } catch (error) {
      Track.track(error);
    }
    
    return (
      <div className="Worldpay3DSChallenge" data-test="Worldpay3DSChallenge">
        <PostToIframe
          postURL={issuerURL}
          formFields={{
            JWT: oneTime3DSToken,
            MD: this.props.use3dsSessionId ? sessionId : cookie.session(),
          }}
          onError={this.handleOnError}
          onLoad={this.handleOnLoad}
        />
      </div>
    );
  }
}

Worldpay3DSChallenge.propTypes = {
  oneTime3DSToken: PropTypes.string.isRequired,
  issuerURL: PropTypes.string.isRequired,
  setErrorOnPage: PropTypes.func.isRequired,
  threeDSecureSuccess: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  sessionId: PropTypes.string,
  use3dsSessionId: PropTypes.bool,
};

const mapStateToProps = state => ({
  threeDSecureData: getThreeDSecureData(state) || null,
  use3dsSessionId: getSettings(state)?.use_3ds_session_id || false,
});

export default connect(mapStateToProps, {threeDSecureSuccess, setErrorOnPage})(Worldpay3DSChallenge);
